import { render, staticRenderFns } from "./NotificationItemBody.vue?vue&type=template&id=7e90f68b"
import script from "./NotificationItemBody.vue?vue&type=script&lang=js"
export * from "./NotificationItemBody.vue?vue&type=script&lang=js"
import style0 from "./NotificationItemBody.vue?vue&type=style&index=0&id=7e90f68b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports